<mat-dialog-content class="payment-schedule">
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
	>
		Payment Schedule
	</epi-heading>
	<p class="payment-schedule__content u-margin-top-small">
		Your first payment is due on the date of purchase and includes a one time admin fee of $25.00. Then your insurance
		policy and Wellness Rewards payment will automatically deduct from your credit/debit card or checking account each
		{{ paymentFrequency$ | async }} and automatically renew each year. Monthly insurance payments include a $1.00
		installment fee.
	</p>
	<section class="payment-schedule__breakdown u-margin-top-small">
		<!-- TODO: Add datasource -->
		<table
			cdk-table
			[dataSource]="data.paymentSchedule"
			class="payment-schedule__table"
		>
			<ng-container cdkColumnDef="date">
				<th
					cdk-header-cell
					*cdkHeaderCellDef
				>Date</th>
				<td
					cdk-cell
					*cdkCellDef="let lineItem"
				>{{ lineItem?.billDate | date:'shortDate' }}</td>
			</ng-container>
			<ng-container cdkColumnDef="premium">
				<th
					cdk-header-cell
					*cdkHeaderCellDef
				>Insurance</th>
				<td
					cdk-cell
					*cdkCellDef="let lineItem"
				>{{ lineItem?.insuranceAmount | currency }}</td>
			</ng-container>
			<ng-container cdkColumnDef="routineCare">
				<th
					cdk-header-cell
					*cdkHeaderCellDef
				>Routine Care</th>
				<td
					cdk-cell
					*cdkCellDef="let lineItem"
				>{{ lineItem?.wellnessAmount || 0 | currency }}</td>
			</ng-container>
			<ng-container cdkColumnDef="total">
				<th
					cdk-header-cell
					*cdkHeaderCellDef
				>Total</th>
				<td
					cdk-cell
					*cdkCellDef="let lineItem"
				>{{ lineItem?.billAmount | currency }}</td>
			</ng-container>
			<tr
				cdk-header-row
				*cdkHeaderRowDef="displayedColumns"
				class="payment-schedule__table-row m--heading"
			></tr>
			<tr
				cdk-row
				*cdkRowDef="let row; columns: displayedColumns"
				class="payment-schedule__table-row"
			></tr>
		</table>
	</section>
</mat-dialog-content>
